(ns app.components.input-field.styles
  (:require-macros)
  (:require [garden.stylesheet :refer [at-media]]
            [spade.core   :refer [defclass]]))

(defclass input-field-style
  []
  {:border "1px solid"
   :border-radius "5px"
   :border-color :theme/*dark98*
   :color :theme/*dark21*
   :width "330px"
   :padding "10px 12px"}
  [:&:focus
   {:border-color :theme/*purplePrimary*
    :box-shadow "none"}]
  [(at-media {:max-width "1340px"}
             {:font-size "40px !important"
              :width "280px"})]
  [(at-media {:max-width "640px"}
             {:font-size "34px !important"})]
  [(at-media {:max-width "500px"
              :width "240px"}
             {:font-size "28px !important"})]
  [(at-media {:max-width "470px"}
             {:font-size "22px !important"})]
  [:&:focus-visible {:outline "none"}])

(defclass label-text-field-folder
  []
  {:border "1px solid"
   :border-radius "5px"
   :font-size "14px"
   :font-weight "700"
   :border-color :theme/*dark98*
   :color :theme/*dark21*
   :width "90%"
   :height "20px"
   :font-family "'Nunito Sans'"
   :outline "none"}
  [:&:focus
   {:border-color :theme/*purplePrimary*
    :box-shadow "none"}]
  [:&:focus-visible {:outline "none"}])

(defclass label-text-field-style
  [padding]
  {:white-space "nowrap"
   :width "239.5px"
   :overflow "hidden"
   :text-overflow "ellipsis"
   :font-weight "700"
   :padding padding
   :font-size "14px"})

(defclass untitled-product-form-label
  [name] {:color (if (= name "") :theme/*grey400*)})

(defclass input-field-xlarge-style
  []
  {:border "1px solid"
   :border-radius "5px"
   :border-color :theme/*dark98*
   :color :theme/*dark21*
   :width "90%"
   :font-size "21px"
   :padding "16px 12px"}
  [:&:focus
   {:border-color :theme/*purplePrimary*
    :box-shadow "none"}]
  [:&:focus-visible {:outline "none"}])

(defclass search-bar-style
  []
  {:border "none"
   :border-color :theme/*dark98*
   :color :theme/*dark21*
   :width "100%"
   :font-size "16px"
   :padding "0px 40px"}
  [:&:focus
   {:border "none"
    :box-shadow "none"}]
  [:&:focus-visible {:outline "none"}])

(defclass search-bar-container
  []
  {:border-bottom "1px solid"
   :border-color :theme/*dark98*
   :position "relative" :width "100%"})